import { render, staticRenderFns } from "./CarsUnionRow.vue?vue&type=template&id=40938496&scoped=true"
import script from "./CarsUnionRow.vue?vue&type=script&lang=ts"
export * from "./CarsUnionRow.vue?vue&type=script&lang=ts"
import style0 from "./CarsUnionRow.vue?vue&type=style&index=0&id=40938496&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40938496",
  null
  
)

export default component.exports